import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from '../../../../app/store/utils/baseQueryWithReauth';

export interface StockOwnerListItemDto {
  id: number;
  companyId: number;
  name: string;
  isActive: boolean;
}

export interface ChannelListItemDto {
  id: number;
  stockOwnerId: number;
  companyId: number;
  type: string;
  isActive: boolean;
  host: string | null;
}

function unwrapData<T>(response: unknown): T {
  if (
    response != null &&
    typeof response === 'object' &&
    'data' in response &&
    (response as { data?: T }).data != null
  ) {
    return (response as { data: T }).data;
  }
  return response as T;
}

export const clientLegalContextApi = createApi({
  reducerPath: 'clientLegalContextApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['StockOwnersByCompany', 'ChannelsByStockOwner'],
  endpoints: build => ({
    getStockOwnersByCompany: build.query<StockOwnerListItemDto[], number>({
      query: companyId => ({
        url: `/system/stock-owners/company/${companyId}`,
        method: 'GET',
      }),
      transformResponse: (response: unknown) =>
        unwrapData<StockOwnerListItemDto[]>(response),
      providesTags: (_r, _e, companyId) => [
        { type: 'StockOwnersByCompany', id: companyId },
      ],
    }),
    getChannelsByStockOwner: build.query<ChannelListItemDto[], number>({
      query: stockOwnerId => ({
        url: `/system/channels/stock-owner/${stockOwnerId}`,
        method: 'GET',
      }),
      transformResponse: (response: unknown) =>
        unwrapData<ChannelListItemDto[]>(response),
      providesTags: (_r, _e, stockOwnerId) => [
        { type: 'ChannelsByStockOwner', id: stockOwnerId },
      ],
    }),
  }),
});

export const {
  useGetStockOwnersByCompanyQuery,
  useGetChannelsByStockOwnerQuery,
} = clientLegalContextApi;
